import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { motion } from "framer-motion";
import PageHero from "../../components/PageHero";
import { useSendMessageMutation } from "../booking/apiSlice";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const toast = useToast();
  const [sendMessage, { isLoading }] = useSendMessageMutation();
  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    if (!name || !email || !message || !/\S+@\S+\.\S+/.test(email)) {
      toast({ title: "Please check your details", description: "Complete every field with a valid email address.", status: "error", isClosable: true });
      return;
    }
    try {
      await sendMessage(formData).unwrap();
      setFormData({ name: "", email: "", message: "" });
      toast({ title: "Message received", description: "We’ll get back to you as soon as possible.", status: "success", isClosable: true });
    } catch (_) {
      toast({ title: "Message not sent", description: "Please try again in a moment.", status: "error", isClosable: true });
    }
  };

  return (
    <div className="bg-[#F8F5EF] text-[#14274A]">
      <PageHero image="/images/general/Block A view.png" eyebrow="Talk to us" title="Here when you need us" copy="Questions, special requests or plans to celebrate? Tell us how we can make your stay exceptional." height="h-[62vh] min-h-[520px]" />
      <section className="mx-auto grid max-w-7xl gap-16 px-6 py-24 sm:px-10 lg:grid-cols-[.75fr_1.25fr] lg:py-32">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="section-eyebrow">Contact Zeebar</p><h2 className="section-title">Let’s start a conversation.</h2><p className="section-copy mt-7">Our team is happy to help with reservations, celebrations, events and every thoughtful detail in between.</p>
          <div className="mt-12 space-y-8 border-t border-[#14274A]/15 pt-8 font-montserrat text-sm">
            <div><span className="block text-[9px] font-bold uppercase tracking-[.2em] text-[#9f7a36]">Visit</span><p className="mt-2 leading-6">Gawadrong (Allay Pakha)<br />Samtse, Bhutan</p></div>
            <div><span className="block text-[9px] font-bold uppercase tracking-[.2em] text-[#9f7a36]">Email</span><a href="mailto:zeebarresort@gmail.com" className="mt-2 block">zeebarresort@gmail.com</a></div>
          </div>
        </motion.div>
        <motion.form initial={{ opacity: 0, y: 35 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} onSubmit={handleSubmit} className="bg-white p-7 shadow-[0_25px_80px_rgba(20,39,74,.1)] sm:p-12">
          <div className="grid gap-8 sm:grid-cols-2"><label className="contact-field"><span>Your name</span><input name="name" value={formData.name} onChange={handleChange} placeholder="How should we address you?" /></label><label className="contact-field"><span>Email address</span><input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" /></label></div>
          <label className="contact-field mt-9"><span>Your message</span><textarea name="message" value={formData.message} onChange={handleChange} rows="7" placeholder="Tell us how we can help…" /></label>
          <button type="submit" disabled={isLoading} className="gold-button mt-9 disabled:opacity-60">{isLoading ? "Sending…" : "Send message"}</button>
        </motion.form>
      </section>
      <iframe title="Zeebar Resort location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.5857166380715!2d89.09537137548904!3d26.88490046128514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e3c1ea4b5e4529%3A0xfdf2eaf12a96d8a8!2sZeebar%20Resort!5e0!3m2!1sen!2sbt!4v1718960124529!5m2!1sen!2sbt" width="100%" height="470" style={{ border: 0, filter: "saturate(.7) contrast(.95)" }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
    </div>
  );
};

export default Contact;
